export interface SocialLink {
  id: 'facebook' | 'instagram' | 'threads' | 'x';
  name: string;
  url: string;
  ariaLabel: string;
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  {
    id: 'facebook',
    name: 'Facebook',
    url: 'https://www.facebook.com/koinon.pro',
    ariaLabel: 'Koinon on Facebook',
  },
  {
    id: 'instagram',
    name: 'Instagram',
    url: 'https://www.instagram.com/koinon.pro/',
    ariaLabel: 'Koinon on Instagram',
  },
  {
    id: 'threads',
    name: 'Threads',
    url: 'https://www.threads.com/@koinon.pro',
    ariaLabel: 'Koinon on Threads',
  },
  {
    id: 'x',
    name: 'X',
    url: 'https://x.com/koinonpro',
    ariaLabel: 'Koinon on X',
  },
] as const;
